// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__D3rYR","container":"styles_container__S9GWa","divider":"styles_divider__XoO2E"};